// @flow

// this HAS to be a default export; the scripts from DFP expect it to be there
/* eslint-disable guardian-frontend/no-default-export */
export default `${location.protocol}//tpc.googlesyndication.com`;



// WEBPACK FOOTER //
// ./static/src/javascripts/projects/commercial/modules/messenger/dfp-origin.js